import FormValidator from '@yaireo/validator'

export default class {
  constructor(form) {
    this.form = form;
    this.validator = new FormValidator(this.validatorSettings, this.form)
    this.validator.texts.empty = "Fill out this field"
  }

  get validatorSettings() {
    return {
      alerts: false,
      classes: {}
    }
  }

  get standardFieldQuerySelector() {
    return 'input:not([type="hidden"]):not([type="radio"]), textarea, select';
  }

  get stimulusFieldSelector() {
    return '[data-controller]';
  }

  get fieldsets() {
    return Array.from(this.form.querySelectorAll('fieldset'));
  }

  get allStandardFields() {
    return Array.from(this.form.querySelectorAll(this.standardFieldQuerySelector)).reverse();
  }

  get allStimulusFields() {
    return Array.from(this.form.querySelectorAll(this.stimulusFieldSelector)).reverse();
  }

  fieldsetValid(fieldset) {
    const fields = Array.from(fieldset.querySelectorAll(this.standardFieldQuerySelector))

    let radios = Array.from(fieldset.querySelectorAll("input[type=\"radio\"]"))
      .reverse()
      .map(x => {
        const valid = x.reportValidity();
        valid ? x.removeAttribute('error') : x.setAttribute('error', true);
        return {
          valid: valid,
          field: x,
          error: valid ? "" : "Fill in this field"
        }
      })

    if (radios.length == 0) {
      radios = [{valid: true}]
    }

    // check optional fields here, as the validator library will check required
    const standardFields = this.optionalFields(fields)
      .reverse()
      .map(x => {
        const valid = x.reportValidity();
        valid ? x.removeAttribute('error') : x.setAttribute('error', true);
        return {
          valid: valid,
          field: x,
          error: valid ? "" : "Fill in this field"
        }
      })

    // will only check fields that are required
    const jsValidatedFields = fields
      .reverse()
      .map(field => {
        const result = this.validator.checkField(field)
        result.error ? field.setAttribute("error", true) : field.removeAttribute("error")
        field.setCustomValidity(result.error)
        field.reportValidity()

        return Object.assign({}, result, {field: field})
      })
    
    const stimulusFields = Array.from(fieldset.querySelectorAll(this.stimulusFieldSelector))
      .reverse()
      .map(x => x.validCheck ? x.validCheck(true) : true);
    
    let isValid = standardFields.every(x => x.valid) && 
                  jsValidatedFields.every(x => x.valid) &&
                  stimulusFields.every(x => x == true) &&
                  radios.every(x => x.valid);

    return {
      valid: isValid,
      errorCount: (standardFields.filter(x => !x.valid).length +
        jsValidatedFields.filter(x => !x.valid).length +
        stimulusFields.filter(x => !x).length) +
        radios.filter(x => !x.valid).length 
    }
  }

  formValid() {
    let radios = Array.from(this.form.querySelectorAll("input[type=\"radio\"]"))
      .reverse()
      .map(x => {
        const valid = x.reportValidity();
        valid ? x.removeAttribute('error') : x.setAttribute('error', true);
        return {
          valid: valid,
          field: x,
          error: valid ? "" : "Fill in this field"
        }
      })

    if (radios.length == 0) {
      radios = [{valid: true}]
    }

    // check optional fields here, as the validator library will check required
    const standardFields = this.optionalFields(this.allStandardFields)
      .map(x => {
        let valid = x.reportValidity();
        valid ? x.removeAttribute('error') : x.setAttribute('error', true);

        return {
          field: x,
          valid: valid,
          error: valid ? "" : "Fill in this field"
        }
      })

    // checks all required fields
    const jsValidatedFields = this.validator.checkAll(this.form)

    jsValidatedFields.fields.forEach(o => {
      o.error ? o.field.setAttribute("error", true) : o.field.removeAttribute("error")
      o.field.setCustomValidity(o.error)
      o.field.reportValidity()
    })
    
    const stimulusFields = this.allStimulusFields.map(x => x.validCheck ? x.validCheck(true) : true); 

    let canSubmit = standardFields.every(x => x) && 
      jsValidatedFields.valid && 
      stimulusFields.every(x => x == true) &&
      radios.every(x => x.valid);

    return {
      valid: canSubmit,
      errorCount: (standardFields.filter(x => !x.valid).length +
              jsValidatedFields.fields.filter(x => !x.valid).length +
              stimulusFields.filter(x => !x).length +
              radios.filter(x => !x.valid).length)
    }
  }

  radioFields(fields) {
    return fields.filter(x => x.type == "radio")
  }

  optionalFields(fields) {
    return fields.filter(x => !x.hasAttribute("required"))
  }
}